import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {openEditModal} from "../../../../../common/utils";
import {
  HouseConsignmentDetailsComponent,
  HouseConsignmentDetailsComponentData
} from "../../house-consignment-details/house-consignment-details.component";
import {IE3ConsignmentProcess} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-consignment-house-column',
    templateUrl: './consignment-house-column.component.html',
    styleUrls: ['./consignment-house-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsignmentHouseColumnComponent {
  @Input() consignmentProcessId: string;
  @Input() consignmentProcess: IE3ConsignmentProcess;
  @Input() houseConsignments: string[];
  @Input() term: string;

  editHouseConsignment = (houseConsignmentNumber: string) => openEditModal(HouseConsignmentDetailsComponent, <HouseConsignmentDetailsComponentData>{
    consignmentProcessId: this.consignmentProcessId,
    consignmentNumber: houseConsignmentNumber,
    cachedConsignmentProcess: this.consignmentProcess
  }, {
    warnOnClose: true,
    currentToStack: true
  });
}
